export default __webpack_public_path__ + "static/WPS-P2P_IN-7011_09-f9021e4443aff68e5fe4d50f9cbd8181.webp";